module.exports = __webpack_public_path__ + "static/img/kp-logo-kcc.fe126b25.png";